import styled from "styled-components";
import { colors } from "definitions";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  width: 100%;
`;

/* Antes era un párrafo azul de 18px seguido de una línea suelta. Como es el
   encabezado de un bloque de preguntas, lleva su propia regla. */
export const Title = styled.h4`
  display: flex;
  align-items: baseline;
  gap: 0.8rem;
  margin: 0 0 1.6rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #eef2f8;
  font-family: Lato;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 2.1rem;
  color: ${colors.icons.darkBlue};

  strong {
    flex: 0 0 auto;
    color: ${colors.fonts.yellowGreen};
  }
`;
